import Splide from '@splidejs/splide';

export default function initSplide() {
    bindDefaultSplideInstances();
	bindHeroSplideInstances();
}

function bindHeroSplideInstances() {
	var splide = new Splide( '.herosplide', {
		type   : 'loop',
		perPage: 1,
		perMove: 1,
		arrows: false,
		autoplay: true,
		interval: 2500,
		type: 'fade',
		rewind     : true,
	} );

	splide.mount();
}


function bindDefaultSplideInstances() {
    // Select all Gutenberg galleries with the "slider" class
    const galleries = document.querySelectorAll('.wp-block-gallery.slider');

    galleries.forEach((gallery, index) => {
        // Create a unique Splide container
        const sliderWrapper = document.createElement('div');
        sliderWrapper.classList.add('splide');
        sliderWrapper.id = `splide-gallery-${index}`;

        // Wrap gallery content into the Splide container
        const slides = Array.from(gallery.children);
        const track = document.createElement('div');
        track.classList.add('splide__track');
        const list = document.createElement('ul');
        list.classList.add('splide__list');

        // Convert gallery images into Splide slides
        slides.forEach((slide) => {
            const li = document.createElement('li');
            li.classList.add('splide__slide');
            li.appendChild(slide);
            list.appendChild(li);
        });

        // Append the structure
        track.appendChild(list);
        sliderWrapper.appendChild(track);

        // Replace the original gallery with the Splide container
        gallery.replaceWith(sliderWrapper);

        // Initialize Splide
        const splide = new Splide(`#splide-gallery-${index}`, {
            type   : 'loop',
            perPage: 1,
            perMove: 1,
            arrows: false,
            autoplay: true,
            interval: 2500,
            type: 'fade',
            rewind: true,
        });

        splide.mount();
    });
}
